const pad = (n) => String(n).padStart(2, '0');

/** Local calendar date as YYYY-MM-DD (the value format of <input type="date"> and the API). */
export const localISODate = (date = new Date()) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// Fixed abbreviations: locale data varies by browser (e.g. en-GB "Sept")
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Presentation only: '2026-10-01' -> '01 Oct 2026'. Returns '' for empty/invalid input. */
export const formatDisplayDate = (isoDate) => {
  if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return '';
  const [y, m, d] = isoDate.split('-').map(Number);
  if (m < 1 || m > 12 || d < 1 || d > 31) return '';
  return `${pad(d)} ${MONTHS[m - 1]} ${y}`;
};
